import { View, Text, StyleSheet, TextInput, TouchableOpacity, ScrollView, Button, Image, Platform, Modal, ActivityIndicator, PixelRatio, Dimensions } from 'react-native'
import React, { useEffect, useState } from 'react'
import { useRoute } from '@react-navigation/native'
import Colours from '../../utils/Colours'
import axios from '../../api/axios'
import { useNavigation } from '@react-navigation/native'
import { useQuery } from '@tanstack/react-query'
import BackArrow from '../../icons/BackArrow'
import ErrorAlertComp from '../../alertComp/ErrorAlertComp'
import useAxiosPrivate from '../../hooks/useAxiosPrivate'
import SuccessAlertComp from '../../alertComp/SuccessAlertComp'
import EmailIcon2 from '../../icons/EmailIcon2'
import EmailIcon from '../../icons/EmailIcon'
import NewPasswordSettings from './NewPasswordSettings'
import AppTextInput from '../../utils/ColourThemes/AppTextInput'

const { width, height } = Dimensions.get('window');
// Base width (e.g., iPhone 11 - 375px)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;

// Function to adjust font size
const dynamicFontSize = (size) => {
    const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
    const newSize = size * scaleFactor;

    return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

// Function for dynamic spacing (padding, margin, gap)
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;

// Function for dynamic sizing (width, height, borderRadius)
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const VerifyEmailCode = ({ email, hideModal, setShowEmailEntry, setIsVerifyEmailCodeVisible }) => {

    const [isCodeFocused, setIsCodeFocused] = useState(false);

    const [isUsernameValid, setIsUsernameValid] = useState(true);
    const [successMessasge, setSuccessMessage] = useState('')
    const [isSuccessCompVisible, setIsSuccessCompVisible] = useState(false)
    const [errorMessage, setErrorMessage] = useState('');
    const [isNewPasswordSettingsVisible, setNewPasswordSettingsVisible] = useState(false)
    const [isErrorCompVisible, setIsErrorCompVisible] = useState(false)

    const [code, setCode] = useState('')

    const [isLoading, setIsLoading] = useState(false)
    const [buttonActive, setButtonActive] = useState(false)

    const navigate = useNavigation()

    const axiosPrivate = useAxiosPrivate()

    useEffect(() => {
        //console.log('EMAIL:', email)
    }, [email])

    const handleEnterCode = (text) => {
        //console.log('code', text)
        setCode(text)

    }

    const submitCode_to_db = async () => {

        if (!code) {
            setIsCodeFocused(true)
            return;
        }

        setIsLoading(true);
        setButtonActive(true)


        try {
            const res = await axios.post('/verifyMailCode/verifyMailCode', { email, resetCode: code });
            //console.log('response', res.data.message);

            if (res.status === 200 || res.status === 201) {
                setNewPasswordSettingsVisible(true)
            } else {
                setErrorMessage('password code verification failed')
                setIsErrorCompVisible(true)
            }
        } catch (error) {
            setErrorMessage(error.response.data.error)
            setIsErrorCompVisible(true)
            //console.log(error);
        } finally {
            setIsLoading(false);
        }
    }


    // if (isLoading) {
    //     return (
    //         <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
    //             <ActivityIndicator size={'large'} color={Colours.PRIMARY} />
    //         </View>
    //     )
    // }

    return (
        <View style={styles.createPullFormContainer}>
            <TouchableOpacity
                onPress={hideModal}
                style={styles.backButtonStyle}
            >
                <BackArrow color={Colours.DARKGRAY} />
            </TouchableOpacity>
            <View style={styles.profilePhotoContainer} >
                <EmailIcon height={dynamicSpacing(40)} width={dynamicSize(40)} color={Colours.PRIMARY} />
            </View>
            <View style={styles.textAndTxtInput}>
                <Text style={{ color: Colours.DARKGRAY, fontSize: dynamicFontSize(15), fontFamily: 'Sen-Regular' }}>
                    Enter the code sent to your email
                </Text>
                <AppTextInput style={[styles.textInputStyle, isCodeFocused && styles.focusedBorder,]}
                    placeholder='Enter Verification code'
                    fontSize={15}
                    keyboardType='numeric'
                    onFocus={() => setIsCodeFocused(true)}
                    onBlur={() => setIsCodeFocused(false)}
                    onChangeText={handleEnterCode}

                />

            </View>
            <TouchableOpacity style={[styles.buttonGray,
            { backgroundColor: buttonActive ? Colours.DARKGRAY : Colours.PRIMARY }]}
                onPress={() => {
                    submitCode_to_db()
                }}
            >
                {isLoading ? (
                    <ActivityIndicator size='small' color='white' />
                ) : (
                    <Text style={{ color: 'white', fontSize: dynamicFontSize(15), fontFamily: 'Sen-Bold' }}>Submit</Text>
                )
                }
            </TouchableOpacity>

            <Modal
                visible={isErrorCompVisible}
                transparent={true}
                animationType="fade"
                onRequestClose={() => setIsErrorCompVisible(false)}
            >
                <ErrorAlertComp
                    message={errorMessage}
                    onClose={() => setIsErrorCompVisible(false)}
                />
            </Modal>
            {/* <Modal
                visible={isSuccessCompVisible}
                transparent={true}
                animationType="fade"
                onRequestClose={() => setIsSuccessCompVisible(false)}
            >
                <SuccessAlertComp
                    message={successMessasge}
                    onClose={() => {
                        setIsSuccessCompVisible(false)
                        //  setIsVerified(true)
                        hideModal()
                    }}
                />
            </Modal> */}

            <Modal
                visible={isNewPasswordSettingsVisible}
                animationType="fade"
                onRequestClose={() => setNewPasswordSettingsVisible(false)}
            >
                <NewPasswordSettings
                    email={email}
                    resetCode={code}
                    hideModal={() => {
                        setNewPasswordSettingsVisible(false)
                    }}
                    setShowEmailEntry={setShowEmailEntry}
                    setIsVerifyEmailCodeVisible={setIsVerifyEmailCodeVisible}
                    setNewPasswordSettingsVisible={setNewPasswordSettingsVisible}
                />
            </Modal>
        </View>
    )
}

const styles = StyleSheet.create({
    createPullFormContainer: {
        flex: 1, // Use flex: 1 to fill the screen
        paddingTop: dynamicSpacing(20),
        padding: dynamicSpacing(15),
        backgroundColor: 'white',
    },
    backButtonStyle: {
        marginBottom: dynamicSize(60),
    },
    textAndTxtInputRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginTop: dynamicSpacing(15),
    },
    textAndTxtInput: {
        marginTop: dynamicSpacing(15),
    },
    textInputStyle: {
        height: dynamicSpacing(50),
        marginTop: dynamicSpacing(10),
        padding: dynamicSpacing(15),
        borderWidth: dynamicSize(1.5),
        borderColor: Colours.DARKLIGHTGRAY,
        borderRadius: dynamicSize(7),
        fontFamily: 'Sen-Regular',
        fontSize: dynamicFontSize(12),
    },
    focusedBorder: {
        borderColor: Colours.PRIMARY,
    },
    buttonGray: {
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: dynamicSize(15),
        marginTop: dynamicSpacing(25),
        height: dynamicSpacing(60),
    },
    profilePhotoContainer: {
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: dynamicSpacing(10),
    },
    userImage: {
        width: dynamicSize(100),
        height: dynamicSize(100),
        borderRadius: dynamicSize(99),
        marginBottom: dynamicSpacing(3),
        borderWidth: dynamicSize(1.5),
        borderColor: Colours.PRIMARY,
        marginTop: dynamicSpacing(10),
        backgroundColor: Colours.LIGHTGRAY,
    },
});


export default VerifyEmailCode


